export default __webpack_public_path__ + "static/media/emi_xl.b7d5d365.jpg";